import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Zap } from 'lucide-react';
import { useState } from 'react';

const Navbar = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { path: '/', label: 'Promo Code' },
    { path: '/rewards', label: 'Rewards' },
    { path: '/how-to-claim', label: 'How to Claim' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-csgo-bg/95 backdrop-blur-md border-b border-csgo-border">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14 sm:h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-1.5 sm:gap-2 group" data-testid="nav-logo">
            <div className="w-8 h-8 sm:w-10 sm:h-10 bg-csgo-primary rounded-lg flex items-center justify-center neon-glow flex-shrink-0">
              <Zap className="w-4 h-4 sm:w-6 sm:h-6 text-black" />
            </div>
            <span className="font-orbitron font-bold text-sm sm:text-base md:text-xl text-white group-hover:text-csgo-primary transition-colors">
              CSGO<span className="text-csgo-primary">LUCK</span>{' '}
              <span className="text-csgo-textMuted text-xs hidden sm:inline">Promo Code</span>
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                className={`px-3 lg:px-4 py-2 font-rajdhani font-semibold text-sm uppercase tracking-wider transition-all duration-200 rounded-lg ${
                  isActive(link.path)
                    ? 'text-csgo-primary bg-csgo-primary/10 border border-csgo-primary/30'
                    : 'text-csgo-textMuted hover:text-white hover:bg-csgo-surface'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* CTA Button - desktop */}
          <a
            href="https://csgoluck.com/r/CS2026"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-claim-btn"
            className="hidden md:flex items-center gap-2 px-4 lg:px-6 py-2 sm:py-2.5 bg-csgo-primary text-black font-orbitron font-bold text-xs sm:text-sm uppercase tracking-wider rounded-lg hover:bg-csgo-primary/90 transition-all duration-200 neon-glow hover:scale-105"
          >
            Claim Bonus
          </a>

          {/* Mobile right side: CTA + Hamburger */}
          <div className="md:hidden flex items-center gap-2">
            <a
              href="https://csgoluck.com/r/CS2026"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center px-3 py-1.5 bg-csgo-primary text-black font-orbitron font-bold text-xs uppercase tracking-wider rounded-lg neon-glow"
            >
              Claim
            </a>
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 text-white hover:text-csgo-primary transition-colors"
              data-testid="mobile-menu-btn"
            >
              {isMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-3 border-t border-csgo-border">
            <div className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMenuOpen(false)}
                  data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                  className={`px-4 py-3 font-rajdhani font-semibold text-base uppercase tracking-wider transition-all duration-200 rounded-lg ${
                    isActive(link.path)
                      ? 'text-csgo-primary bg-csgo-primary/10 border border-csgo-primary/30'
                      : 'text-csgo-textMuted hover:text-white hover:bg-csgo-surface'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="https://csgoluck.com/r/CS2026"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="mobile-claim-btn"
                className="mt-2 flex items-center justify-center gap-2 px-6 py-3 bg-csgo-primary text-black font-orbitron font-bold text-sm uppercase tracking-wider rounded-lg neon-glow"
              >
                Claim Bonus Now
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
